import { css } from '@emotion/react';

import { styled } from '../../../styled';
import { Theme } from '../../../theme/interface/detailed';
import { Button } from '../../buttons';

export const NewQuestionButton = styled(Button)(
	({ theme }: { theme: Theme }) => theme.chat.buttons.newQuestion,
	({
		theme: {
			chat: {
				buttons: {
					newQuestion: { hoverBackgroundColor },
				},
			},
		},
	}: {
		theme: Theme;
	}) =>
		css`
			&:hover {
				background-color: ${hoverBackgroundColor};
			}
		`
);
